import React, { useState } from "react";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import { EmployeesPanel } from "./EmployeesPanel";
import { ContractsPanel } from "./ContractsPanel";
import { RunsPanel } from "./RunsPanel";
import { MemberPicker } from "components/MemberPicker";

export function RemuneracionesView() {
  const [memberId, setMemberId] = useState(null);
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3, alignItems: "center", flexWrap: "wrap", gap: 2 }}>
        <Typography variant="h5" fontWeight={700}>Remuneraciones</Typography>
        <MemberPicker value={memberId} onChange={setMemberId} />
      </Box>

      {!memberId ? (
        <Paper sx={{ p: 4, textAlign: "center", color: "text.secondary" }}>Selecciona un cliente</Paper>
      ) : (
        <>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs value={tab} onChange={(_, v) => setTab(v)}>
              <Tab label="Empleados" />
              <Tab label="Contratos" />
              <Tab label="Liquidaciones" />
            </Tabs>
          </Box>
          {tab === 0 && <EmployeesPanel memberId={memberId} />}
          {tab === 1 && <ContractsPanel memberId={memberId} />}
          {tab === 2 && <RunsPanel memberId={memberId} />}
        </>
      )}
    </Box>
  );
}
